<template>
  <page-wrapper :title="title" :no-pad-btm="true">
    <div class="d-flex justify-content-start" style="height: 100%">
      <list-item
        v-model="PackageGroupMainPagePresenter.groups"
        class="col-3 px-0 d-flex flex-column"
        @createCategory="handleCreateCategory"
      ></list-item>
      <div v-if="isSelectedGroup" class="col-9 px-0 d-flex flex-column">
        <item-selector
          v-model="PackageGroupMainPagePresenter.packageGroup.packages"
          :group-name="PackageGroupMainPagePresenter.packageGroup.name"
          :is-affect-app="PackageGroupMainPagePresenter.packageGroup.isAffectApp"
          :all-item="PackageGroupMainPagePresenter.allPackage"
          :deleted-at="PackageGroupMainPagePresenter.packageGroup.deletedAt"
          @selectedItem="handleSelectedItem"
          @removedItem="handleRemovedItem"
          @removedAllItem="handleRemovedAllItem"
          @searchItem="handleSearchItem"
          @updateGroup="handleUpdateGroup"
          @cancelGroup="handleCancelGroup"
        ></item-selector>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ListItem from "@/features/group/components/ListItem";
import ItemSelector from "@/features/group/components/ItemSelector/ItemSelector";
import { isNil } from "ramda";
import { MessageBox } from "element-ui";
import { toCamelCaseObject } from "@/lib/util";
import { PackageGroupMainPagePresenter } from "@/presenters/group/package-group/PackageGroupMainPagePresenter";
import { GroupUseCase } from "@/usecases/GroupUseCase";

export default {
  components: {
    PageWrapper,
    ListItem,
    ItemSelector
  },
  data() {
    const title = "Package Group";
    const searchKeyword = "";
    const form = {
      groups: [],
      packageGroup: {
        id: null,
        name: null,
        packages: [],
        isAffectApp: null,
        deletedAt: null
      },
      allPackage: []
    };

    return {
      title,
      form,
      searchKeyword
    };
  },
  computed: {
    PackageGroupMainPagePresenter() {
      const form = {
        ...this.form,
         allPackage: this.filteredPackages
      };

      return new PackageGroupMainPagePresenter(form);
    },
    isSelectedGroup() {
      return !isNil(this.selectedGroupId);
    },
    selectedGroupId() {
      return this.$route.params.id;
    },
    isRJB2BGroupSelected() {
      return this.isSelectedGroup
        ? this.form.groups.some(
            (group) =>
              String(group.id) === String(this.selectedGroupId) &&
              group.name === "RJB2B"
          )
        : false;
    },
    filteredPackages() {
      const searchTerm = this.searchKeyword.toLowerCase();

      return this.form.allPackage.filter((pkg) => {
        const nameMatch = pkg.name.toLowerCase().includes(searchTerm);

        const isPackageGroupsEmpty = pkg.packageGroups.length === 0;
        const isNotRJB2BGroup = pkg.packageGroups.some((group) => group.name !== "RJB2B");

        const packageGroupsMatch = this.isRJB2BGroupSelected
          ? isPackageGroupsEmpty
          : isPackageGroupsEmpty || isNotRJB2BGroup;

        return nameMatch && packageGroupsMatch;
      });
    },
  },
  watch: {
    $route(newRoute, oldRoute) {
      if (newRoute.path !== oldRoute.path) {
        this.setupPackageGroup();
      }
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupGroups();
      this.setupPackageGroup();
      this.setupAllPackage();
    },
    async setupGroups() {
      this.form.groups = await GroupUseCase.list();
    },
    async setupPackageGroup() {
      if (!this.selectedGroupId) {
        return;
      }

      const { id, name, packages, isAffectApp, deletedAt } =
        await GroupUseCase.getPackageGroup(this.selectedGroupId);

      this.form.packageGroup = {
        id,
        name,
        packages: toCamelCaseObject(packages),
        isAffectApp,
        deletedAt
      };
    },
    async setupAllPackage() {
      const allPackage = await GroupUseCase.getAllPackage();

      this.form.allPackage = toCamelCaseObject(allPackage);
    },
    updatePackageGroupsForItem(itemId, mutatePackageGroups) {
      this.form.allPackage = this.form.allPackage.map((pkg) =>
        pkg.id === itemId
          ? { ...pkg, packageGroups: mutatePackageGroups(pkg.packageGroups) }
          : pkg
      );
    },
    handleSelectedItem(itemId) {
      const selectedPackage = this.form.allPackage.find(
        (item) => item.id === itemId
      );

      this.form.packageGroup.packages.push(selectedPackage);

      this.updatePackageGroupsForItem(itemId, (groups) => [
        ...groups,
        { id: this.form.packageGroup.id, name: this.form.packageGroup.name }
      ]);
    },
    handleRemovedItem(itemId) {
      this.form.packageGroup = {
        ...this.form.packageGroup,
        packages: this.form.packageGroup.packages.filter(
          (item) => item.id !== itemId
        ),
      };

      this.updatePackageGroupsForItem(itemId, (groups) =>
        groups.filter((group) => group.id !== this.form.packageGroup.id)
      );
    },
    handleRemovedAllItem() {
      this.form.packageGroup.packages = [];
    },
    handleSearchItem(keyword) {
      this.searchKeyword = keyword;
    },
    async handleUpdateGroup() {
      try {
        const {id} = this.form.packageGroup;
        const packageIds = this.getPackageIds();

        await GroupUseCase.updatePackageGroup(id, packageIds);

        this.$message.success("อัพเดท Group สำเร็จ");
      } catch (error) {
        this.$message.error("ไม่สามารถอัพเดท Group ได้ กรุณาลองใหม่อีกครั้ง");
      }
    },
    async handleCancelGroup() {
      try {
        await MessageBox.confirm(
          `ยืนยันการลบ ${this.form.packageGroup.name}`,
          {
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก"
          }
        );
      } catch (e) {
        return;
      }

      const packageGroupId = this.form.packageGroup.id;

      await this.cancelGroup(packageGroupId);
    },
    async cancelGroup(packageGroupId) {
      try {
        await GroupUseCase.cancelPackageGroup(packageGroupId);

        await this.setupData();
        this.$message.success("ยกเลิก Group สำเร็จ");
      } catch (error) {
        this.$message.error("ไม่สามารถยกเลิก Group ได้ กรุณาลองใหม่อีกครั้ง");
      }
    },
    getPackageIds() {
      const packageIds = this.form.packageGroup.packages.map((item) =>
        item.id.toString()
      );

      return packageIds;
    },
    async handleCreateCategory(category) {
      await GroupUseCase.post(category);

      this.setupData();
      this.$message.success("เพื่มหมวดหมู่เรียบร้อย");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  padding: 30px;
  border-bottom: $border;

  background: #f9f9f9;
}

.sc-btn {
  display: inline-block;
  width: auto;
  padding: 6px 20px;
}
</style>
